export const layoutCopy = {
  "en-GB": {
    "layout.button": "Layout",
    "layout.choose": "Choose layout",
    "layout.simple": "Simple",
    "layout.modern": "Modern",
    "layout.technical": "Technical",
    "layout.modern2": "Modern",
    "layout.accessible": "Age-friendly",
    "layout.description.modern2": "Clear display with large text.",
    "layout.description.accessible": "Clear display with large text.",
    "layout.quickActions": "Quick actions",
    "layout.description.simple": "Clear display with large text.",
    "layout.description.modern": "Clear display with large text.",
    "layout.description.technical": "Clear display with large text.",
    "layout.sameFeatures": "Both contain the same maps, activity, functions and settings. Only the appearance changes.",
    "layout.savedNote": "When signed in, your choice is saved to your account and restored at your next login.",
    "layout.unsaved": "The appearance changed on this screen, but could not be saved. Try choosing it again when connected.",
    "layout.tools": "Tools and language",
    "layout.details": "Details"
  },
  "da-DK": {
    "layout.button": "Layout",
    "layout.choose": "Vælg layout",
    "layout.simple": "Enkel",
    "layout.modern": "Moderne",
    "layout.technical": "Teknik",
    "layout.modern2": "Moderne",
    "layout.accessible": "Ældrevenlig",
    "layout.description.modern2": "Tydelig visning med stor tekst.",
    "layout.description.accessible": "Tydelig visning med stor tekst.",
    "layout.quickActions": "Hurtige handlinger",
    "layout.description.simple": "Tydelig visning med stor tekst.",
    "layout.description.modern": "Tydelig visning med stor tekst.",
    "layout.description.technical": "Tydelig visning med stor tekst.",
    "layout.sameFeatures": "Begge har de samme kort, aktiviteter, funktioner og indstillinger. Kun udseendet ændres.",
    "layout.savedNote": "Når du er logget ind, gemmes valget på din konto og hentes ved næste login.",
    "layout.unsaved": "Visningen er ændret på skærmen, men kunne ikke gemmes. Vælg den igen, når forbindelsen er tilbage.",
    "layout.tools": "Værktøjer og sprog",
    "layout.details": "Detaljer"
  }
};
